/**
 * @description 全小写
 * @param {string} string
 * @returns {string}
 */
export const caseAllSmall = (string: string): string => {
  return String(string).toLowerCase()
}

